import React, { useState } from 'react';
import LoginPage from './LoginPage';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import SignUpPage from './SignUpPage';
import { useAppDispatch, useAppSelector, useAppTranslation } from 'app/hooks';
import { onChangeAuthPage, selectShowAuthPage } from 'features/home/homeSlice';
import ForgotPassword, { SendMailType } from './ForgotPasswordPage';
import ResetPasswordPage from './ResetPasswordPage';
import LoadingSpinner from 'components/Commons/LoadingSpinner';
import { useLoading } from 'hooks/useLoading';
import { useNavigate } from 'react-router-dom';
import loginBg from '../../../assets/images/login_bg.png';
import signUpBg from '../../../assets/images/signUp_bg.png';
import { isLaptop, isPhone, isTablet } from 'utils/commonUtils';
import { platformStates } from 'redux/platformSlice';
interface AuthPageProps {}

const AuthPage: React.FunctionComponent<AuthPageProps> = () => {
  const showAuthPage = useAppSelector(selectShowAuthPage);
  const t = useAppTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const platform = useAppSelector(platformStates);
  const [isResetFields, setIsResetFields] = useState<boolean>(false);
  const [isShowForgotPassword, setIsShowForgotPassword] = useState<boolean>(false);
  const [isShowResetPassword, setIsShowResetPassword] = useState<boolean>(false);
  const [isShowResendActiveLink, setIsShowResendActiveLink] = useState<boolean>(false);
  const [userEmail, setUserEmail] = useState<string>('');
  const { isLoading, onChangeLoadingStatus } = useLoading();
  const handleChangeTab = (value: number) => {
    if (showAuthPage === value) return;
    dispatch(onChangeAuthPage(value));
  };

  const onClosePageClick = () => {
    if (isShowForgotPassword) {
      setIsShowForgotPassword(false);
      return;
    }
    if (isShowResetPassword) {
      setIsShowResetPassword(false);
      return;
    }
    if (isShowResendActiveLink) {
      setIsShowResendActiveLink(false);
      return;
    }
    dispatch(onChangeAuthPage(-1));
    setIsResetFields((prev) => !prev);
  };

  const onSendOTPSuccess = (email: string) => {
    setUserEmail(email);
    setIsShowResetPassword(true);
    setIsShowForgotPassword(false);
  };

  const onResendLinkSuccess = (email: string) => {
    setIsShowResendActiveLink(false);
  };

  const onResendActiveLink = () => {
    setIsShowForgotPassword(false);
    setIsShowResendActiveLink(true);
  };

  return (
    <div
      className={`max-overlay center-content-col primary-text-color ${
        showAuthPage !== -1 ? 'show' : 'hidden'
      }`}
    >
      <div className="auth-form relative">
        <div className="auth-form__header">
          {isShowForgotPassword ? (
            <h2>{t('forgotPassword.title')}</h2>
          ) : isShowResetPassword ? (
            <h2>{t('resetPassword.title')}</h2>
          ) : isShowResendActiveLink ? (
            <h2>{t('resend-active-link.title')}</h2>
          ) : (
            <>
              <button
                className={`${!showAuthPage ? 'active' : ''}`}
                onClick={() => handleChangeTab(0)}
              >
                {t('authPage.header.login')}
              </button>
              <button
                className={`${!showAuthPage ? '' : 'active'}`}
                onClick={() => handleChangeTab(1)}
              >
                {t('authPage.header.signup')}
              </button>
            </>
          )}
        </div>
        <button className="btn-close" onClick={onClosePageClick} type="button">
          <AiOutlineCloseCircle />
        </button>
        {isShowForgotPassword ? (
          <ForgotPassword
            onSendSuccess={onSendOTPSuccess}
            type={SendMailType.FORGOT_PASSWORD}
            titleLabel={t('forgotPassword.label')}
            buttonText={t('forgotPassword.button-text')}
            onChangeLoadingStatus={onChangeLoadingStatus}
            onResendActiveLink={onResendActiveLink}
          />
        ) : isShowResetPassword ? (
          <ResetPasswordPage
            email={userEmail}
            closePage={() => setIsShowResetPassword(false)}
            onChangeLoadingStatus={onChangeLoadingStatus}
          />
        ) : isShowResendActiveLink ? (
          <ForgotPassword
            onSendSuccess={onResendLinkSuccess}
            type={SendMailType.RESEND_ACTIVE_LINK}
            titleLabel={t('resend-active-link.label')}
            buttonText={t('resend-active-link.button-text')}
            onChangeLoadingStatus={onChangeLoadingStatus}
          />
        ) : (
          <>
            {!showAuthPage ? (
              <LoginPage
                isResetFields={isResetFields}
                onShowForgotPassword={() => setIsShowForgotPassword(true)}
                onShowResendActiveLink={() => setIsShowResendActiveLink(true)}
                onChangeLoadingStatus={onChangeLoadingStatus}
              />
            ) : (
              <SignUpPage
                isResetFields={isResetFields}
                onChangeLoadingStatus={onChangeLoadingStatus}
              />
            )}
          </>
        )}

        {isLoading && (
          <div className="common-loading border-radius-30">
            <LoadingSpinner className="common-loading__body" />
          </div>
        )}
        {!(isPhone(platform) || isTablet(platform) || isLaptop(platform)) && (
          <img src={!showAuthPage ? loginBg : signUpBg} className="login_bg" />
        )}
      </div>
    </div>
  );
};

export default AuthPage;
